export const userMilestonesInterface = {
    welcomeAt: undefined,
    firstMediaImportedAt: undefined,
    firstMediaPublishedAt: undefined,
}
